/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import {
  MasterZoneModulePermissionNodeDto,
  MasterZoneModulePermissionTreeDto,
} from './master-zone-module-permission.dto';

export const MasterZoneModulPermissionNodeMapper = entity<MasterZoneModulePermissionNodeDto>();
export const MasterZoneModulePermissionTreeMapper = entity<MasterZoneModulePermissionTreeDto>();
